import { useTranslation } from "react-i18next";
import { useSourcesPanel } from "../hooks/useSourcesPanel";
import { faviconUrl, sourceHost } from "../lib/sources";
import type { Source } from "../lib/sseEvents";

/** Compact trigger that opens the side panel with all of a turn's sources. */
export function SourcesButton({ sources }: { sources: Source[] }) {
  const { t } = useTranslation();
  const { toggle } = useSourcesPanel();
  if (sources.length === 0) return null;

  return (
    <button
      type="button"
      onClick={() => toggle(sources)}
      className="inline-flex items-center gap-2 rounded-pill bg-bubble py-1 pl-1.5 pr-3 font-sans text-[12.5px] font-medium text-ink outline-none transition-colors duration-150 ease-house hover:bg-tint focus-visible:bg-tint"
    >
      <span className="flex -space-x-1.5">
        {sources.slice(0, 3).map((source, i) => {
          const host = sourceHost(source.url);
          return host ? (
            <img
              key={`${source.url}-${i}`}
              src={faviconUrl(host)}
              alt=""
              aria-hidden="true"
              loading="lazy"
              width={16}
              height={16}
              className="size-4 rounded-full bg-paper ring-2 ring-paper"
            />
          ) : null;
        })}
      </span>
      {t("chat.thread.sources")}
    </button>
  );
}
